// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Provider } from 'react-redux';

import type { AppStore } from 'app/MyApp';

interface IProps extends React.ComponentProps<any> {
  store: AppStore;
}

export function StoreProvider({ store, children }: IProps) {
  return <Provider store={store}>{children}</Provider>;
}
